


<template>
    <div class="top" @click="back">

        <div class="back">

            返回

        </div>
        <div class="t">
            资产详情
        </div>
    </div>
    <div v-if="product" style="text-align: center;">






        <div style="padding: 10px" class="flex">
            <div style="width: 25vw;text-align: left;color: #999;">
                资产名称:
            </div>
            <div style="flex:1;text-align: left;font-weight: bold;">
                {{ product.name }}
            </div>
        </div>
        


       


       

        <div style="padding: 10px" class="flex">
            <div style="width: 25vw;text-align: left;color: #999;">
                资产价值:
            </div>
            <div style="flex:1;text-align: left;font-size: 12px;">
                {{ product.price }}
            </div>
        </div>
        <div style="padding: 10px" class="flex">
            <div style="width: 25vw;text-align: left;color: #999;">
                可使用年限:
            </div>
            <div style="flex:1;text-align: left;display: flex; overflow-x: auto;">
                <el-tag >{{ product.nx }}</el-tag>
            </div>
        </div>
        <div style="padding: 10px" class="flex">
            <div style="width: 25vw;text-align: left;color: #999;">
                已使用年限:
            </div>
            <div style="flex:1;text-align: left;display: flex; overflow-x: auto;">
                <el-tag >{{ product.ysy_nx }}</el-tag>
            </div>
        </div>
        <div style="padding: 10px" class="flex">
            <div style="width: 25vw;text-align: left;color: #999;">
                资产折旧率:
            </div>
            <div style="flex:1;text-align: left;font-size: 12px;">
                {{ product.zjl }}
            </div>
        </div>
        <div style="padding: 10px" class="flex">
            <div style="width: 25vw;text-align: left;color: #999;">
                折旧后价值:
            </div>
            <div style="flex:1;text-align: left;font-size: 12px;">
                {{  product.price - (( product.price) * product.zjl * product.ysy_nx * 0.01) }}
            </div>
        </div>
        <div style="margin-top: 20px;">

        </div>


        <div>

        </div>
    </div>
    <div v-else style="text-align: center;margin: 50px;">
        <div>
            未能识别到资产信息,请关闭页面重新扫码
        </div>

    </div>


    <el-dialog v-model="dialogFormVisible" title="出入库" width="100%">


        <div class="flex d">
            <div class="l">数量</div>
            <div class="r"><el-input type="number" name="" id="" v-model="number" placeholder="请输入要操作的数量"
                    style="width: 200px;" /></div>
        </div>
        <div class="flex d">
            <div class="l">仓库</div>
            <div class="r">


                <el-select v-model="w_id" clearable placeholder="请选择仓库" filterable style="width: 200px;">
                    <el-option v-for="o in ws" :key="o.id" :label="o.name" :value="o.id" />
                </el-select>
            </div>
        </div>
        <div class="flex d" v-if="type == 2 && w_id == 1">
            <div class="l">存放区域</div>
            <div class="r">


                <el-select v-model="q_id" clearable placeholder="请选择存放区域" filterable style="width: 200px;">
                    <el-option v-for="o in qs" :key="o.id" :label="o.name" :value="o.id" />
                </el-select>
            </div>
        </div>
        <template #footer>

            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="commit()">
                    {{ type == 1 ? "出库" : "入库" }}
                </el-button>
            </span>

        </template>
    </el-dialog>

    <el-dialog v-model="dialogFormVisible2" title="修改备注" width="100%">


        <div class="flex d">
            <div class="l">备注</div>
            <div class="r"><el-input type="text" name="" id="" v-model="remark" placeholder="请输入备注" style="width: 200px;" />
            </div>
        </div>


        <template #footer>

            <span class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取消</el-button>
                <el-button type="primary" @click="commit2()">
                    修改
                </el-button>
            </span>

        </template>
    </el-dialog>
    <input type="file" @change="changefile" :data-name="img" hidden class="zjimg" accept="image/*" multiple="multiple"
        capture="camera">
</template>

<script setup>
import { useMainStore } from "/store/mainStore.js"
import { useRoute, useRouter } from "vue-router"
import { onMounted, ref, watch } from "vue";
import { getAssetDetail } from "@/api/asset"
import { ElMessage } from "element-plus";
const dialogFormVisible = ref(false)
const dialogFormVisible2 = ref(false)
const type = ref(1)
const number = ref()
const store = useMainStore()
const id = ref()
const q_id = ref()
const qs = ref([])
const product = ref()
const kucun = ref([])
const w_id = ref()
const ws = ref([])
const back = () => {
    router.back()
}
const remark = ref()
const router = useRouter()
const currItem = ref()
const route = useRoute()

let file
const src = ref()

const changefile = async (e) => {

    if (e.target.files.length > 0) {
        src.value = URL.createObjectURL(e.target.files[0]);

        file = e.target.files[0];

        // 创建一个 FileReader 对象
        var reader = new FileReader();

        // 设置读取完成后的回调函数
        reader.onload = function (e) {
            // 创建一个新的图片元素
            var img = new Image();

            // 设置图片的src为读取到的文件数据
            img.src = e.target.result;

            // 图片加载完成后执行
            img.onload = function () {
                // 创建一个Canvas元素
                var canvas = document.createElement("canvas");

                // 获取Canvas的2D上下文
                var ctx = canvas.getContext("2d");

                // 设置Canvas的大小为图片的实际大小
                canvas.width = img.width;
                canvas.height = img.height;

                // 将图片绘制到Canvas上
                ctx.drawImage(img, 0, 0);

                // 压缩图片，可以调整压缩质量（0.1 到 1 之间）
                var compressedDataURL = canvas.toDataURL("image/jpeg", 0.8);

                // 压缩后的数据可用于上传或展示

                function dataURLtoFile(dataURL, fileName) {
                    // 将Base64数据部分提取出来
                    var base64Data = dataURL.split(',')[1];

                    // 将Base64转换为Blob对象
                    var blob = b64toBlob(base64Data, 'image/jpeg');

                    // 创建一个File对象
                    var file = new File([blob], fileName, { type: 'image/jpeg' });

                    return file;
                }

                // 将Base64转换为Blob对象的辅助函数
                function b64toBlob(b64Data, contentType, sliceSize) {
                    contentType = contentType || '';
                    sliceSize = sliceSize || 512;

                    var byteCharacters = atob(b64Data);
                    var byteArrays = [];

                    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        var slice = byteCharacters.slice(offset, offset + sliceSize);

                        var byteNumbers = new Array(slice.length);
                        for (var i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }

                        var byteArray = new Uint8Array(byteNumbers);

                        byteArrays.push(byteArray);
                    }

                    var blob = new Blob(byteArrays, { type: contentType });
                    return blob;
                }


                var fileName = compressedDataURL;
                var file2 = dataURLtoFile(compressedDataURL, fileName);
                ElMessage.info("正在上传图片!")
                updateProdcutImg({ id: product.value.id, img: file2 }).then(res => {
                    if (res.code == 200) {
                        getProduct(id.value).then(res => {
                            product.value = res.data
                            kucun.value = res.kucun
                            ws.value = res.ws
                            qs.value = res.qs
                        })
                        e.target.files = []

                        ElMessage.success("上传成功!")
                    }
                })
            };
        };

        // 读取文件数据
        reader.readAsDataURL(file);



    }

}
const checkImage = () => {


    src.value = ""
    file = null

    document.querySelector(".zjimg").click();
}
if (route.query.id) {

    id.value = route.query.id

    getAssetDetail(id.value).then(res => {
        product.value = res.data
        
    })
}

watch(() => route.query.id, (i) => {

    if (i != id.value) {
        id.value = i
        getAssetDetail(id.value).then(res => {
            product.value = res.data
         
        })
    }

})

const commit2 = () => {
    if (!remark.value) {

        ElMessage.error("请输入备注")
        return
    }

    xgRemark({ remark: remark.value, id: product.value.id }).then(res => {
        dialogFormVisible2.value = false
        getProduct(id.value).then(res => {
            product.value = res.data
            kucun.value = res.kucun
            ws.value = res.ws
            qs.value = res.qs
        })
    })
}
const commit = () => {
    if (!number.value) {

        ElMessage.error("请输入数量")
        return
    }
    if (!w_id.value) {
        ElMessage.error("请选择仓库")
        return
    }
    if (w_id.value == 1 && !q_id.value && type == 1) {
        ElMessage.error("原材料仓库请选择存放区域")
        return
    }

    churuku({ id: id.value, number: number.value, type: type.value, w_id: w_id.value, q_id: q_id.value }).then(res => {
        if (res.code == 200) {
            ElMessage.success(res.msg)
            dialogFormVisible.value = false
            getProduct(id.value).then(res => {
                product.value = res.data
                kucun.value = res.kucun
                ws.value = res.ws
                qs.value = res.qs
            })
        } else {
            ElMessage.error(res.msg)
        }
    })
}
</script>


<style scoped lang="scss">
.el-dialog {
    --el-dialog-width: 80%;
}

.tabbar {
    position: fixed;
    bottom: 0;
    width: 100vw;
    left: 0;
    display: flex;
    height: 5vh;
    background-color: #f7f7f7;
    align-items: center;
    border-top: 1px solid #eee;

    div {
        flex: 1;
        text-align: center;
        color: #666;
    }

    .select {
        color: #5677fc;
        font-weight: bold;
    }
}

.time {
    font-size: 12px;
    color: #999;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.button {
    padding: 0;
    min-height: auto;
}

.image {
    width: 100%;
    display: block;
}

.card-header {
    display: flex;
    justify-content: center;
    align-items: center;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.box-card {
    width: 480px;
}

.top {
    display: flex;
    height: 5vh;
    align-items: center;
    border-bottom: 1px solid #eee;

    .back {
        width: 20vw;
        text-align: center;
        color: #5677fc;

    }

    .t {
        flex: 1;
        text-align: center;
        margin-left: -20vw;
        font-weight: bold;

    }
}
</style>